<div class="container m-3 ">
  <h2>Admin Dashboard</h2>

  <ul class="nav nav-tabs" role="tablist">
    <li class="nav-item" role="presentation">
      <button class="nav-link" [class.active]="selected === 'shows'" (click)="selected = 'shows'"
      type="button">Shows</button>
    </li>
    <li class="nav-item" role="presentation">
      <button class="nav-link" [class.active]="selected === 'music'" (click)="selected = 'music'"
      type="button">Music</button>
    </li>
    <li class="nav-item" role="presentation">
      <button class="nav-link" [class.active]="selected === 'users'" (click)="selectUserTab()"
      type="button">Users</button>
    </li>
  </ul>

  <div class="tab-content p-3">
    @if (selected === 'shows') {
      <div>
        <h3>Shows</h3>
        <app-grid [rows]="shows" (create)="onGridCreate()" (edit)="onGridEdit($event)"
        (delete)="onGridDelete($event)"></app-grid>
        <!-- Modal for create/edit -->
        @if (isModalOpen) {
          <div class="modal-backdrop">
            <div class="modal-dialog modal-lg">
              <div class="modal-content p-3">
                <h4>{{ editMode ? 'Edit Show' : 'Create Show' }}</h4>
                <div class="mb-2">
                  <label class="form-label">Title</label>
                  <input class="form-control" [(ngModel)]="modalModel.title" />
                </div>
                <div class="mb-2">
                  <label class="form-label">Date</label>
                  <input class="form-control" type="date" [(ngModel)]="modalModel.date" />
                </div>
                <div class="mb-2">
                  <label class="form-label">Location</label>
                  <input class="form-control" [(ngModel)]="modalModel.location" />
                </div>
                <div class="mb-2">
                  <label class="form-label">Url</label>
                  <input class="form-control" [(ngModel)]="modalModel.url" />
                </div>
                <div class="mt-2 align-self-end">
                  <button class="btn btn-secondary" (click)="closeModal()">Cancel</button>
                  <button class="btn btn-primary mx-2" (click)="submitModal()">{{ editMode ? 'Save' : 'Create'
                  }}</button>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }

    @if (selected === 'music') {
      <div>
        <h3>Music</h3>
        <p>Manage music here.</p>
      </div>
    }

    @if (selected === 'users') {
      <div>
        <h3>Users</h3>
        <app-grid [rows]="users" (create)="onUserCreate()" (edit)="onUserEdit($event)"
        (delete)="onUserDelete($event)"></app-grid>
      </div>
    }
  </div>
</div>